import type { FC, MouseEvent, ReactNode } from 'react';
import { FaAngleDown } from 'react-icons/fa';
import { Button, Tooltip, Typography } from '@mui/material';

import { styles } from './index.styles';

interface OpenFilterGroupButtonProps {
  filter: Array<string>;
  onClick: (event: MouseEvent<HTMLElement>) => void;
  showTooltip: boolean;
  children?: ReactNode;
}

const OpenFilterGroupButton: FC<OpenFilterGroupButtonProps> = ({
  filter,
  onClick,
  showTooltip,
  children,
}) => (
  <Tooltip title={showTooltip && filter.join(', ')}>
    <Button
      fullWidth
      variant="ctaSecondary"
      onClick={onClick}
      sx={styles.openFilterGroupButton}
      aria-label={`${children} filter`}
    >
      <Typography
        component="span"
        noWrap
        sx={styles.openFilterGroupButtonLabel}
      >
        {filter.length
          ? `${filter[0]}${filter.length > 1 ? ` +${filter.length - 1}` : ''}`
          : children}
      </Typography>
      <FaAngleDown />
    </Button>
  </Tooltip>
);

export default OpenFilterGroupButton;
